/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/*Internal Nav Container in Product Detail Page Navigation  */
function scrollToElementWithStickyOffset(e, id) {
  // Shopify-section-template--18887384170844__judgeme_section_review_widget_737d
  var headerElement = document.querySelector("[id^='shopify-section-sections--'][id$='__header']");
   
  _scrollTo('#' + id, 0 - headerElement.offsetHeight);
}
// this is set up to have generic ids so shopify fetches the genric one 
function scrollToReviews(e){
  const reviewElement = document.querySelector("[id^='shopify-section-template--'][id$='__judgeme_section_review_widget_737d']");
  const reviewElementId = reviewElement.id;
   var headerElement = document.querySelector("[id^='shopify-section-sections--'][id$='__header']");
  _scrollTo('#' + reviewElementId, 0 - headerElement.offsetHeight);
}
// this is set up to have generic ids so shopify fetches the genric one 
function scrollToPayments(e){
  const paymentElement = document.querySelector("[id^='shopify-section-template--'][id$='__ShippingandPaymentDetails']");
  const paymentElementId = paymentElement.id;
   var headerElement = document.querySelector("[id^='shopify-section-sections--'][id$='__header']");
  _scrollTo('#' + paymentElementId, 0 - headerElement.offsetHeight);  
}

function _scrollTo(selector, yOffset = 0){
  const el = document.querySelector(selector);
  if (!el || el === undefined) return;
  const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
  window.scrollTo({top: y, behavior: 'smooth'});
}
/*End of Internal Nav Container in Product Detail Page Navigation  */
/* Start of 3D Model function*/
let modelBanner3D = document.getElementById('modelBanner3D');
if (modelBanner3D) {
  modelBanner3D.addEventListener('click', function() {
    open3dModal();
  });
}
/* End of 3D Model function*/
/*Start of thumbnail scroller  */
// Check if the right arrow element exists before adding the click event listener
let rightThumbnailArrow = document.querySelector('.thumbnail-right-arrow');
if (rightThumbnailArrow) {
  rightThumbnailArrow.addEventListener('click', function() {
    let scrollerInner = document.querySelector('.scroller__inner');
    if (scrollerInner) {
      scrollerInner.scrollBy({ left: -300, behavior: 'smooth' });
    } 
  });
} 
// Check if the left arrow element exists before adding the click event listener
let leftThumbnailArrow = document.querySelector('.thumbnail-left-arrow');
if (leftThumbnailArrow) {
  leftThumbnailArrow.addEventListener('click', function() {
    let scrollerInner = document.querySelector('.scroller__inner');
    if (scrollerInner) {
      scrollerInner.scrollBy({ left: 300, behavior: 'smooth' });
    } else {
      // console.error("scroller__inner element not found");
    }
  });
} 
/*End of thumbnail scroller  */
/* Start of removing extra p tag in description*/
document.addEventListener('DOMContentLoaded', function() {
    var descriptionContainer = document.querySelector('.rte.text--pull.product-description');
    if (descriptionContainer) {
        var paragraphsExtraSpace = descriptionContainer.querySelectorAll('p');
        // Iterate over the paragraphs to find the one with '&nbsp;'
        paragraphsExtraSpace.forEach(function(p) {
            // Check if the paragraph contains only '&nbsp;'
            if (p.innerHTML.trim() === '&nbsp;') {
                // Remove the paragraph from the DOM
                p.remove();
            }
        });
    }
});

/* End of removing extra p tag in description*/
/* Start of gempages replace FAQ image */
var faqImgElement = document.querySelector('.custom-faq-img');
let faq_locale = Shopify.locale;
if (faqImgElement && faq_locale == 'fr') {
  var imgElementFAQ = faqImgElement.querySelector('img');
  if (imgElementFAQ) {
    imgElementFAQ.src = 'https://cdn.shopify.com/s/files/1/0790/0902/2294/files/FAQ_header_FR.png?v=1705321578';
  } 
};
/* End of gempages replace FAQ image*/

// Function to get primary locale 
function getPrimaryLocale(hostname) {
    // Default to Dutch for .nl and .be domains, or for .com domains serving primarily Dutch content
    if (hostname.endsWith('.nl') || hostname.endsWith('.be') || hostname.endsWith('.com')) {
      return 'nl';
    } 
    // Default to French for .fr domains
    else if (hostname.endsWith('.fr')) {
      return 'fr';
    }
    return 'nl'; // Default locale 
  }

// KISS - here we are changing the phone number, avatar link and text for FR language alone 
document.addEventListener('DOMContentLoaded', function () {
  // Select the necessary elements
  const whatsappLink = document.querySelector('.wa__stt');
  const buttonLink = document.querySelector('.wa__button');
  const memberName = document.querySelector('.wa__member_name');
  const imageWrapper = document.querySelector('.wa__cs_img_wrap');
  const popupAvatarImage = document.querySelector('.wa__popup_avatar .wa__cs_img_wrap');
  const csName = document.querySelector('.wa__cs_name');

  if (whatsappLink) {
    // Check the Shopify locale
    const locale = Shopify?.locale || '';

    // If the locale is 'fr', update the phone number, names, image, and button
    if (locale.toLowerCase() === 'fr') {
      // Update the WhatsApp phone number for both links
      whatsappLink.setAttribute('href', 'https://api.whatsapp.com/send?phone=32477561193');
     

      if (buttonLink) {
        buttonLink.setAttribute('href', 'https://api.whatsapp.com/send?phone=32477561193');
      
      }

      // Update the member name
      if (memberName) {
        memberName.textContent = "Guy Perin";
      
      }

      // Update the CS name
      if (csName) {
        csName.textContent = "Guy Perin";

      }

      // Update the main image URL inside the background style
      if (imageWrapper) {
        imageWrapper.style.backgroundImage = 'url("https://cdn.shopify.com/s/files/1/0790/0902/2294/files/WhatsApp_Image_2025-05-01_at_09.45.45.jpg?v=1746614944")';
      }

      // Update the nested avatar image if exists
      if (popupAvatarImage) {
        popupAvatarImage.style.backgroundImage = 'url("https://cdn.shopify.com/s/files/1/0790/0902/2294/files/WhatsApp_Image_2025-05-01_at_09.45.45.jpg?v=1746614944")';

      }
    } else {
      // If not FR, just extract the phone number normally
      const hrefValue = whatsappLink.getAttribute('href');
      const phoneMatch = hrefValue.match(/phone=(\d+)/);

      if (phoneMatch) {
        const phoneNumber = phoneMatch[1];
      } else {
        console.log("Phone number not found in the URL.");
      }
    }
  } else {
    console.log("Element with class '.wa__stt' or '.wa__button' not found.");
  }
});


// KISS - Changing the phone number and email in footer for FR language 
document.addEventListener('DOMContentLoaded', function () {
  // ===========================
  // Update Phone Number
  // ===========================
  const phoneLink = document.querySelector('a[href^="tel:+32488098881"]');

  if (phoneLink) {
    const locale = Shopify?.locale || '';

    if (locale.toLowerCase() === 'fr') {
      phoneLink.setAttribute('href', 'tel:+32477561193');
      phoneLink.setAttribute('title', 'tel:+32477561193');
      phoneLink.textContent = '+32 (0)477 56 11 93';
    }
  } else {
    console.log("Phone link with href '+32488098881' not found.");
  }

  const phoneWrapper = document.querySelector('.mobile-menu__help-wrapper');

  if (phoneWrapper) {
    const phoneSpan = phoneWrapper.querySelector('span');
    const locale = Shopify?.locale || '';

    if (locale.toLowerCase() === 'fr') {
      phoneSpan.textContent = '+32 (0)477 56 11 93';
    }
  } else {
    console.log("Phone wrapper not found.");
  }

  // ===========================
  // Update Email Address
  // ===========================
  const locale = Shopify?.locale || '';
  console.log("Locale detected:", locale);
   const emailLinks = document.querySelectorAll('a[href^="mailto:info@mywoodbuildkit.com"]');
  console.log("Email Links Found:", emailLinks);

  if (emailLinks.length > 0) {
    emailLinks.forEach(emailLink => {
      if (locale.toLowerCase() === 'fr') {
        console.log("FR locale detected - changing email to sales@mywoodbuildkit.com");
        emailLink.setAttribute('href', 'mailto:sales@mywoodbuildkit.com');
        emailLink.setAttribute('title', 'mailto:sales@mywoodbuildkit.com');
        emailLink.textContent = 'sales@mywoodbuildkit.com';
      } else {
        console.log("Locale is not FR - keeping default email info@mywoodbuildkit.com");
        emailLink.setAttribute('href', 'mailto:info@mywoodbuildkit.com');
        emailLink.setAttribute('title', 'mailto:info@mywoodbuildkit.com');
        emailLink.textContent = 'info@mywoodbuildkit.com';
      }
    });
  } else {
    console.log("❌ No email links with href 'mailto:info@mywoodbuildkit.com' found.");
  }
});




  document.addEventListener("DOMContentLoaded", function () {
  console.log("Inside link");
    const link = document.getElementById("contactPageShowrrom");

    if (window.location.hostname === "monkitconstrubois.fr" &&
        window.location.pathname === "/pages/showroom") {
      link.setAttribute("href", "/pages/contact");
    }
  });

